import React from 'react'
import { Col } from 'reactstrap'

export default function FixedSelector({ children, name }) {
  //convert selector name to display name
  const displayNames = {
    districts: 'District',
    schools: 'School',
    teachers: 'Teacher',
    classes: 'Class',
  }

  return (
    <Col xs='6' sm='3' className='fixed selector'>
      <span className='title'>{displayNames[name]}: </span><br />
      <span className='value'>{children}</span>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/SelectorComponents/FixedSelector.js